// Reports — admin /reports landing tile menu (CHG-1659).
//
// Spec authority: specs/tier-05-experience/reports.entity-hint.yaml
// (pages.menu_v2 block). Documented hand-roll exception per DRIFT-702
// (v2gen.py has no menu_v2 emit mode today).

import { Link } from "react-router-dom";
import { PageHeader } from "../components/composition/PageHeader";

interface ReportTile {
  id: string;
  title: string;
  description: string;
  route: string;
}

const TILES: ReportTile[] = [
  {
    id: "analytics",
    title: "Analytics dashboard",
    description:
      "Real-time KPIs: donation timeline, source mix, payment-method breakdown, donor lifecycle. Drill-down ready.",
    route: "/reports/analytics",
  },
  {
    id: "annual",
    title: "Annual reports",
    description:
      "Year-by-year giving totals with monthly breakdown, source mix, top donors. Compliance + board-pack ready.",
    route: "/reports/annual",
  },
  {
    id: "impact",
    title: "Impact reports",
    description:
      "Outcomes summary: donations raised, donors reached, programs funded, campaign goals met over a chosen window.",
    route: "/reports/impact",
  },
];

function ReportCard({ tile }: { tile: ReportTile }) {
  return (
    <Link
      to={tile.route}
      style={{
        display: "block",
        padding: 16,
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        borderRadius: 8,
        textDecoration: "none",
        color: "var(--color-text)",
      }}
      aria-labelledby={`report-tile-${tile.id}-title`}
    >
      <h2
        id={`report-tile-${tile.id}-title`}
        style={{ fontSize: 16, fontWeight: 600, margin: "0 0 6px" }}
      >
        {tile.title}
      </h2>
      <p
        style={{
          fontSize: 13,
          color: "var(--color-text-muted)",
          margin: 0,
          lineHeight: 1.4,
        }}
      >
        {tile.description}
      </p>
    </Link>
  );
}

export function Reports() {
  return (
    <main
      role="main"
      style={{ maxWidth: 1280, margin: "0 auto", padding: "16px 24px 48px" }}
    >
      <PageHeader
        title="Reports"
        subtitle="Org-wide analytics + annual + impact reports for board packs, year-end giving statements, and operational reviews."
      />
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: 16,
          marginTop: 16,
        }}
      >
        {TILES.map((tile) => (
          <ReportCard key={tile.id} tile={tile} />
        ))}
      </div>
    </main>
  );
}
